import React from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { farmOutAPI, farmOutStateLabel } from '../../services/farmOutApi';

export default function FarmOutReservationPanel({
  reservationId,
}: {
  reservationId: string;
}) {
  const query = useQuery(
    ['farm-out-context', reservationId],
    () => farmOutAPI.context(reservationId),
    { retry: false, staleTime: 15000 }
  );
  if (!query.data) return null;
  const { offer, eligible, reason } = query.data;
  return (
    <section
      className="rounded-lg border border-outline p-4 mb-4"
      aria-label="Reservation farm-out"
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="font-semibold">
            {offer ? farmOutStateLabel(offer) : 'Farm-out'}
          </h3>
          <p className="text-sm text-on-surface-variant">
            {offer?.state === 'awarded'
              ? 'Fulfillment belongs to the selected operator. Your company retains the reservation and billing.'
              : eligible
              ? 'Offer this trip to another approved operator.'
              : reason}
          </p>
        </div>
        <Link
          className="btn-secondary"
          to={`/admin/farm-outs?reservation=${reservationId}`}
        >
          {offer ? 'Manage handoff' : 'Offer reservation'}
        </Link>
      </div>
    </section>
  );
}
